import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _toConsumableArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import Vue from 'vue';
export function SET_DATA(state, payload) {
  state[payload.state] = payload.data;
}
export function SET_ARRAY(state, payload) {
  state[payload.state] = _toConsumableArray(payload.data);
}
export function PUSH_ARRAY(state, payload) {
  state[payload.state] = [].concat(_toConsumableArray(state[payload.state]), _toConsumableArray(payload.data));
}
export function REMOVE_FROM_ARRAY(state, payload) {
  state[payload.state] = state[payload.state].filter(function (i) {
    return i[payload.key] !== payload.data[payload.key];
  });
}
export function SET_ENTRY(state, payload) {
  state.entry = payload.data || null;
}
export function SET_COMMENTS(state, _ref) {
  var data = _ref.data,
    meta = _ref.meta;
  state.comments = data;
  state.commentsMeta = meta;
}
export function APPEND_COMMENT(state, payload) {
  state.comments.unshift(payload);
}
export function UPDATE_COMMENT(state, payload) {
  var foundIndex = state.comments.findIndex(function (ac) {
    return ac.id === payload.id;
  });
  if (foundIndex >= 0) {
    var comment = _objectSpread(_objectSpread({}, state.comments[foundIndex]), payload);
    Vue.set(state.comments, foundIndex, comment);
  }
}
export function UPDATE_COMMENT_CHILDREN(state, payload) {
  var parentComments = state.commentsChildren[payload.parent_id];
  var foundIndex = parentComments.findIndex(function (pc) {
    return pc.id === payload.id;
  });
  if (foundIndex >= 0) {
    parentComments[foundIndex] = payload;
    state.commentsChildren = _objectSpread(_objectSpread({}, state.commentsChildren), _defineProperty({}, payload.parent_id, _toConsumableArray(parentComments)));
  }
}
export function DELETE_COMMENT_CHILD(state, payload) {
  var parentComments = state.commentsChildren[payload.parentId];
  var foundIndex = parentComments.findIndex(function (pc) {
    return pc.id === payload.id;
  });
  if (foundIndex >= 0) {
    parentComments.splice(foundIndex, 1);
    state.commentsChildren = _objectSpread(_objectSpread({}, state.commentsChildren), _defineProperty({}, payload.parentId, _toConsumableArray(parentComments)));
  }
}
export function SET_COMMENT_CHILDREN(state, payload) {
  // Update comments
  var comments = payload.meta.current_page > 1 ? [].concat(_toConsumableArray(state.commentsChildren[payload.commentId]), _toConsumableArray(payload.data)) : payload.data;
  state.commentsChildren = _objectSpread(_objectSpread({}, state.commentsChildren), _defineProperty({}, payload.commentId, comments));

  // Update commentsMeta
  state.commentsChildrenMeta = _objectSpread(_objectSpread({}, state.commentsChildrenMeta), _defineProperty({}, payload.commentId, payload.meta));
}
export function APPEND_COMMENT_CHILDREN(state, payload) {
  var comments = state.commentsChildren[payload.parent_id] ? [payload].concat(_toConsumableArray(state.commentsChildren[payload.parent_id])) : state.commentsChildren[payload.parent_id] = [payload];

  // Update parent's count
  var foundIndex = state.comments.findIndex(function (c) {
    return c.id === payload.parent_id;
  });
  if (foundIndex >= 0) {
    var parent = state.comments[foundIndex];
    Object.assign(state.comments[foundIndex], parent.children_count = parent.children_count + 1);
  }
  state.commentsChildren = _objectSpread(_objectSpread({}, state.commentsChildren), _defineProperty({}, payload.parent_id, comments));
}
export function CLEAR_COMMENT_CHILDREN(state, parentId) {
  delete state.commentsChildren[parentId];
  delete state.commentsChildrenMeta[parentId];
  state.commentsChildren = _objectSpread({}, state.commentsChildren);
  state.commentsChildrenMeta = _objectSpread({}, state.commentsChildrenMeta);
}
export function UPDATE_UNSEENS(state, payload) {
  var auditSeens = payload.data.map(function (as) {
    return as.audit_comment_id;
  }).flat();
  state.unseens = state.unseens.filter(function (u) {
    return !auditSeens.includes(u.audit_comment_id);
  });
}
export function SET_AUDIT_PARAMS(state, payload) {
  var params = payload || {
    include: 'entity,user',
    page: 1,
    flag_id: null,
    entity: null,
    days: null
  };
  state.auditParams = _objectSpread(_objectSpread({}, state.auditParams), params);
}
export function UPDATE_CONCEPT_ACTION_ON_AUDIT(state, payload) {
  var index = state.comments.findIndex(function (a) {
    return a.id === payload.audit_comment_id;
  });
  if (index >= 0) {
    state.comments[index].concept_action = payload;
  }
}
export function SET_ACTION(state, payload) {
  if (state.entry && state.entry.auditComments) {
    var auditCommentIndex = state.comments.findIndex(function (a) {
      return a.id === payload.audit_comment_id;
    });
    state.comments[auditCommentIndex].concept_action.model_actions_count = payload.model_actions_count;
  }
}
export function SET_ACTION_AS_DELETED(state, actionId) {
  var comments = state.comments;
  comments.forEach(function (a) {
    if (a.concept_action && a.concept_action.id === actionId) {
      a.concept_action.deleted_at = 1;
    }
  });
  state.comments = comments;
}
export function SET_CLOSED(state, payload) {
  // Update entry
  var entry = state.entry;
  entry.closed = payload.value;
  state.entry = entry;

  // Update state list
  var auditIndex = state.audits.findIndex(function (s) {
    return s.id === payload.audit_id;
  });
  state.audits[auditIndex].closed = payload.value;
}
export function UPDATE_AUDITS(state, payload) {
  payload.data.forEach(function (item) {
    var foundIndex = state.audits.findIndex(function (a) {
      return a.id === item.id;
    });
    Vue.set(state.audits, foundIndex, item);
  });
}
export function UPDATE_PROPERTY(state, payload) {
  state[payload.state][payload.prop] = payload.value;
}